import { useState, useCallback, useRef } from 'react';

/**
 * Shared drag state and refs for flowchart node dragging.
 */
export function useFlowchartDragState(nodeDimensions) {
  const nodeDimensionsRef = useRef(nodeDimensions);
  nodeDimensionsRef.current = nodeDimensions;

  const [draggingNode, setDraggingNode] = useState(null);
  const [potentialDragNode, setPotentialDragNode] = useState(null);
  const [hasDragged, setHasDragged] = useState(false);
  const [autoArrangeBlocked, setAutoArrangeBlocked] = useState(false);
  const [dropTarget, setDropTarget] = useState(null);
  const [dragLayoutTick, setDragLayoutTick] = useState(0);

  const dropTargetRef = useRef(null);
  const dragOffsetRef = useRef({ x: 0, y: 0 });
  const dragStartPosRef = useRef({ x: 0, y: 0 });
  const dragStartCanvasPosRef = useRef({ x: 0, y: 0 });
  const initialPositionsRef = useRef({});
  const currentDragPositionsRef = useRef({});
  const draggingNodeRef = useRef(null);

  const flushDragLayoutTick = useCallback(() => {
    setDragLayoutTick((n) => n + 1);
  }, []);

  return {
    nodeDimensionsRef,
    draggingNode,
    setDraggingNode,
    potentialDragNode,
    setPotentialDragNode,
    hasDragged,
    setHasDragged,
    autoArrangeBlocked,
    setAutoArrangeBlocked,
    dropTarget,
    setDropTarget,
    dragLayoutTick,
    dropTargetRef,
    dragOffsetRef,
    dragStartPosRef,
    dragStartCanvasPosRef,
    initialPositionsRef,
    currentDragPositionsRef,
    draggingNodeRef,
    flushDragLayoutTick,
  };
}
